import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import { getGameBackground } from '../scenes/GameBackground';

export default class Cup extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     * @param {number} cupColor
     * @param {string} cupValue
     * @param {} pRef
     */
    constructor(scene, x, y, cupColor, cupValue, pRef)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.cupColor = cupColor;
        this.cupValue = cupValue;
        this.readyColor = gameData.READY_COLOR;
        this.unreadyColor = gameData.UNREADY_COLOR;
        this.parentRef = pRef;
        this.isReady = false;
        this.isDisposed = false;
        this.animationReady = true;

        this.cupBase = ABCyaPhaser.Images.addImage(0, 0, 'game-items/cup-' + this.cupColor + '_0', this);
        this.cupLetter = ABCyaPhaser.Text.addText(0, 6, 60, this.unreadyColor, FontKeys._odin_roundedregular, this.cupValue.toUpperCase(), this).setOrigin(0.5);

        this.alpha = 0;

        this.showTextReady(false);
    }

    showTextReady(ready)
    {
        this.isReady = ready;
        let newTxtColor = (this.isReady) ? this.readyColor : this.unreadyColor;
        this.cupLetter.setColor(Phaser.Display.Color.IntegerToColor(newTxtColor).rgba);
        this.cupLetter.alpha = (this.isReady == true) ? 1 : 0.25;
        if (this.isDisposed == true) this.cupLetter.alpha = 0;
    }

    bounceIn(xPos, yPos)
    {
        //random side
        this.animationReady = false;
        let randomSide = Phaser.Math.Between(0, 1);
        //start a little below final y
        this.x = (randomSide == 0) ? -this.cupBase.width : this.scene.scale.width + (this.cupBase.width);
        this.y = yPos + 200;
        let randomRotationDir = Phaser.Math.Between(0, 1);
        let startRotation = (randomRotationDir == 0) ? -600 : 600;
        this.angle = startRotation;
        //arc tween with spin to position
        let startX = this.x;
        this.alpha = 1;

        const path = new Phaser.Curves.Path(this.x, this.y).quadraticBezierTo(xPos, yPos, startX + ((xPos - startX) / 2), yPos - 200);
        ABCyaPhaser.Tweens.addPathTween(this, path, 750, null, Phaser.Math.Easing.Sine.Out, this.finishAnimation.bind(this));
        ABCyaPhaser.Tweens.addTween(this, 500, { angle: randomRotationDir == 0 ? "+=600" : "-=600" }, Phaser.Math.Easing.Quadratic.Out);
    }

    dropIn(xPos, yPos)
    {
        //add above final position
        this.animationReady = false;
        this.y = -this.cupBase.height;
        this.x = xPos;
        this.alpha = 1;
        ABCyaPhaser.Tweens.addTween(this, 750, { y: yPos }, Phaser.Math.Easing.Quadratic.In, this.finishAnimation.bind(this));
    }

    spinOff(side)
    {
        //get side
        this.animationReady = false;
        let endX = (side == "left") ? this.x - this.scene.scale.width - this.cupBase.width : this.x + this.scene.scale.width + this.cupBase.width;
        //tween x with spin
        let endRotation = (side == "left") ? -1440 : 1440;
        ABCyaPhaser.Tweens.addTween(this, 750, { x: endX, angle: endRotation }, Phaser.Math.Easing.Quadratic.In);
    }

    flipUp()
    {
        //yoyo tween up with spin
        this.animationReady = false;
        let startY = this.y;
        let spinDirection = Phaser.Math.Between(0, 1);
        let endRotation = (spinDirection == 0) ? -360 : 360;

        const path = new Phaser.Curves.Path(this.x, this.y).quadraticBezierTo(this.x, startY, this.x, startY - 600,);
        ABCyaPhaser.Tweens.addPathTween(this, path, 750, null, Phaser.Math.Easing.Quadratic.InOut, this.finishAnimation.bind(this));
        ABCyaPhaser.Tweens.addTween(this, 500, { angle: endRotation }, Phaser.Math.Easing.Quadratic.InOut);
    }

    flipBack(movePos = 1)
    {
        this.animationReady = false;
        this.cupLetter.setColor("#000000");
        //arc tween with spin and scale down to random x position and horizon - cup height/2
        let startX = this.x;
        let startY = this.y;
        let endX = Phaser.Math.Between(0, this.scene.scale.width);
        let endY = getGameBackground().horizon - ((this.cupBase.height / 2) * .5);
        let spinDirection = Phaser.Math.Between(0, 1);
        let endRotation = (spinDirection == 0) ? -360 : 360;

        const path = new Phaser.Curves.Path(this.x, this.y).quadraticBezierTo(endX, endY, startX + ((endX - startX) / 2), startY - 200);
        ABCyaPhaser.Tweens.addPathTween(this, path, 750, null, Phaser.Math.Easing.Sine.Out, this.finishAnimation.bind(this));
        ABCyaPhaser.Tweens.addTween(this, 500, { angle: endRotation, scale: 0.75 }, Phaser.Math.Easing.Quadratic.Out);

        if (this.parentContainer)
        {
            this.parentContainer.moveTo(this, movePos);
        }
        else this.scene.children.moveTo(this, movePos);
        this.cupLetter.alpha = 0;
    }

    finishAnimation()
    {
        this.animationReady = true;
        this.angle = 0;
        this.emit(ANIMATION_FINISHED, this);
    }
}

export const ANIMATION_FINISHED = 'ANIMATION_FINISHED';